import { Component, EventEmitter, Input, Injector, ViewChild, Inject } from '@angular/core';
import { ResourceService } from '../../../shared/services/resource.service';
import { DiagnosedItem } from '../../dataModels/diagnosed-item';
import { INotifier, INotifierToken } from '../../dataModels/contracts/INotifier';
import { MessageDialog } from '../messageDialog/message-dialog.component';
import { NotifierProviderService } from '../../providers/notifier-provider.service';

@Component({
    moduleId: module.id,
    selector: 'notifier',
    templateUrl: 'notifier.component.html'
})
export class NotifierComponent extends DiagnosedItem {
    @ViewChild(MessageDialog) messagDialog: MessageDialog;

    public OnNotify: EventEmitter<string> = new EventEmitter<string>();

    constructor(@Inject(INotifierToken) private notifierSrv: INotifier, protected __inj: Injector) {
        super(__inj);

        this.notifierSrv.OnNotify.subscribe(this.notify);
        this.notifierSrv.onOkButtonVisibilityChnage.subscribe(this.setOkButtonVisibility);
        this.notifierSrv.onDismissButtonVisibilityChnage.subscribe(this.setDismissButtonVisibility);
    }

    notify = (message: string, options?: any) => {
        this.messagDialog.message = message;

        this.messagDialog.show();
    };

    setOkButtonVisibility = visibility => this.messagDialog.showConfirmBtn = visibility;

    setDismissButtonVisibility = visibility => this.messagDialog.showDismissBtn = visibility;
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/notifier/notifier.component.ts